import { AxiosResponse } from 'axios';
import { BaseService } from '@services/route.service';
import { SaveSalesGoalsRequest } from './requests/save-sales-goals.request';
import { SalesGoalsMonthResponse } from './responses/sales-goals.response';

export class SalesGoalsService extends BaseService {
    protected get resourceName(): string {
        return 'crm/dashboard';
    }

    public async goals(year: number, month: number): Promise<AxiosResponse<{ data: SalesGoalsMonthResponse }>> {
        return await this.get('goals', { year, month });
    }

    public async save(request: SaveSalesGoalsRequest): Promise<AxiosResponse<void>> {
        return await this.put('goals', request);
    }
}
